export const CDN_BASE_URL = import.meta.env.VITE_CDN_BASE_URL;
